import SupportBundlePackManagerPage from './SupportBundlePackManagerPage'

export default function SupportClinicLocationBundlePacksPage() {
  return <SupportBundlePackManagerPage scopeType="clinic-location" />
}
